




import React, { useState, useEffect, useRef } from 'react';

import getNLS from '../../common/_NLS';

import SingleReply from './SingleReply';
import { ajaxor, ajaxor2, isLogon } from '../../common/basic';

export default props => {
  if(!props.me) return <></>;

  const [v, set] = React.useState(null);
  React.useEffect(() => {
    inputRef1.current.value = ''; // 댓글입력박스 초기화
    $(' .dib.pictures')[0]?.scrollTo(0, 0); // 스크롤위로
    return () => { ; };
  });

  
  const [vThisList, setThisList] = useState([]);
  const inputRef1 = useRef(null);
  const [vParent, setParent] = useState(null); // null: 댓글모드, 2341: 대댓글모드

  
  // 댓글달기 통신
  function registerReply() {
    if (!isLogon()){
      alert('로그인을 하셔야 합니다.');
      return;
    }

    ajaxor2({
      url:"/inspiration/comment/"+props.me.id, 
      type:"post", 
      "data": {
        "content": inputRef1.current.value
      },
      callback: appendThisList
    });
    function appendThisList(r) {
      inputRef1.current.value = '';
      setThisList([r.comment, ...vThisList]);

      // 댓글카운트 span들 1씩 플러스
      $(".cc-" + props.me.id).text(parseInt($(".cc-" + props.me.id)[0].innerText) + 1);

    }
  }

  // 대댓글달기 통신
  function rere(rid) {
    ajaxor2({
      url: "/inspiration/commentre/" + rid,
      type: "post",
      "data": {
        "content": inputRef1.current.value
      },
      callback: appendThisList
    });
    function appendThisList(rd) {
      inputRef1.current.value = '';

      // 복제하면서 들어갈위치를 카운트 한다.
      var newList=[];
      var left = 0;
      vThisList.map((v,i)=>{
        newList.push(v);
        if (v.id >= rd.comment.id && v.seq <= rd.comment.seq){
          left=i;
        }
      });
      newList.splice(left+1, 0, rd.comment);
      setThisList(newList);

      setParent(null);// 대댓글=>댓글모드로 복원

      // setThisList([r.comment, ...vThisList]);
    }
  }

  // 댓글 삭제 통신
  function deleteReply(rid, seq=0) {
    // if(1==1) return;
    ajaxor2({
      url: "/inspiration/comment/delete/" + rid
        +(seq>0? "?seq="+seq:""),
      callback: deleteCallback
    });
    function deleteCallback(rd) {
      var newReplies = [];
      if (rd&&rd.count<1){
        alert('처리되지 않았습니다.');
        return;
      }
      vThisList && vThisList.map((v, i, a) => {

        // 대댓글삭제면 댓글번호도 맞아야함
        if (seq > 0 && rid == v["id"] && seq == v["seq"]) return false;

        // 댓글
        if (seq <= 0 && rid == v["id"]) return false;

        newReplies.push(v);
      });
      setThisList(newReplies);
    }

  }

  useEffect(()=>{
    if (typeof props.me.id == 'undefined') return;

    // 댓글목록 조회
    ajaxor2({
      url:'/inspiration/comments/'+props.me.id,
      callback: setThisList,
    });
  }, [props.me.id]);

  return (<div className="">
    <style jsx>{`

.small-title{
  padding: 0 0 20px 0;
  font-size: 12px;
  color: #343a40;
}


`}</style>
    <div>&nbsp;</div>
    {/* <div className="small-title">{getNLS("댓글")}(<span>{vThisList ? vThisList.length:0}</span>)</div> */}
    <div className="small-title">{getNLS("댓글")}(<span className={"cc-" + props.me.id} >{!props.me?'':props.me.comment_count}</span>)</div>

    {vThisList&&vThisList.map((v, i, a) => (
      <div key={i}><SingleReply me={v}
        onSelectDelete={() => deleteReply(v["id"], v["seq"])}
        onSelectRERE={e=>{
          setParent(v["id"]);
          inputRef1.current.focus();
        }}
      /></div>
    ))}


    <style jsx>{`

.bottom{
    padding: 10px 0px 2px 5px;

}

.write-reply-input{
  padding:10px 5px;
  border: 0;
  width: 70%;
  font-size: 16px;
}

.blackbutton55 {
    width: 55px;
    height: 32px;
    line-height: 32px;
    background-color: #343a40;
  
    margin: 5px 2px;
    border: solid 1px #adb5bd;

    font-size: 14px;
    text-align: center;
    color: white;
  
    box-sizing: border-box;
}

.horizon-bar {
    width: 100%;
    height: 1px;
    /* margin:10px; */
    /* - 댓글작성/등록 아래 밑줄 바로 아래로 붙이기 */
    background-color: #e9ecef;
}

.rere-write{
  margin:0 0 0 30px;
  /* background-color: red; */
}



@media all and (max-width:606px) {
  .write-reply-input{
    /* font-size: 16px; */
  }
}


`}</style>
    <div className={"bottom " + (vParent ? "rere-write" : "")} >
      <a style={{ display: (vParent ? "initial" : "none")}} 
        // 대댓글=>댓글모드로 복원
        onClick={()=> setParent(null)}
      > * </a>
      <input ref={inputRef1} className="write-reply-input" 
        // placeholder={(vParent ? " 답글 작성" : " 댓글 작성")} 
      />
      <a><div className="dib blackbutton blackbutton55" onClick={() => {
        if (vParent)
          rere(vParent);
        else
          registerReply();
      }}>등록</div></a>
    </div>

    <div className="horizon-bar" />

    <div>&nbsp;</div>
    <div>&nbsp;</div>
  </div>);
}
